import { BasemapKey, IMapContainer } from "../types"

export type BasemapKeyViewModel = BasemapKey

export function getVisibleBasemapKeysWatcher(map: IMapContainer) {

    let state: BasemapKeyViewModel[] = undefined

    return () => {

        if (!map) {
            return undefined
        }

        const keys = map.getAdditionalBasemaps()
            .filter(g => g.visible && g.basemap?.key && g.showKey)
            .map(g => g.basemap.key)

        if (state && (state.length === keys.length) && (state.every(b => keys.some(o => o === b)))) {
            return state
        }

        state = keys

        return state

    }

}
